module.exports = __webpack_public_path__ + "img/465.4f8d00fb.png";